/**
 * 
 */
var analyticsAlertLabel;

function onShowPopUpActions(){
	$('.menu__layer').on('click',function(){
		$('.menu__layer').removeClass('is-active');
		$('.pop-up-contacto').removeClass('is-active');
		$(body).removeClass("blocking");
		$('.pop-up-contacto').trigger('contacto:close');
	});
	$('.pop-up-contacto .pop-up__arrow a').on('click',function(){
		$('.menu__layer').removeClass('is-active');
		$('.pop-up-contacto').removeClass('is-active');
		$(body).removeClass("blocking");
		$('.pop-up-contacto').trigger('contacto:close');
	});
	$('.pop-up-contacto').on('contacto:close',function(){
		$('.pop-up-contacto .toggle-area').css('max-height','0px');	
	});
	$('#contacto-textarea').on('focus',function(){
		$('.pop-up-contacto .toggle-area').css('max-height','5000px');	
	});
	
	$('.pop-up-contacto').addClass('is-active');
	$('.menu__layer').addClass('is-active');
	$(body).addClass("blocking");
	if ($('.pop-up-contacto.is-active').css('position')!='fixed') {
		$(document).scrollTop(0);
	}
}

$(document).ready(function(){
	setAnalyticsAlertLabel();
	
	$('.create-alert-visitor').on('click',function(){
		var data = $('#searchLocationFilterForm').serialize();
		data+='&origin='+$(this).attr('data-origin');
		$('.pop-up-contacto').empty();
		$('.pop-up-contacto').load('/www/resem/new_design/common/pop-up-alert.jsp', data, function(){
			

			analytics.submitCreateAlert('listing-open', analyticsAlertLabel);
			onShowPopUpActions();						
			
			$('#create-alert').on('click', function(){
				
				$(".alert-properties").find("*").removeClass("has-error");
				var fieldToValidate = $("#mail-for-alert");
				var checkToValidate = $("#checkAcceptPrivacyText");
				if(toggleError(fieldToValidate.attr("data-type"), fieldToValidate) || (checkToValidate.length>0 && !checkToValidate.is(":checked"))) {
					if(!checkToValidate.is(":checked")){
						$(checkToValidate).next().addClass("has-error");
					}
					return false;
				}
					
//				if(!.val()){
//					$("#mail-for-alert").addClass('has-error');
//					return false;
//				}
				
				$.ajax({
			         data: {
				            "email" : $("#mail-for-alert").val()
			 	     },
			         url:   '/createClientForAlertsServlet',
			         dataType : 'json',
			       	 type:  'post',
			         beforeSend: function () {
			         },
			         success:  function (response) {
			         	if(response.bean.resultCode == "0") {
			         		createAlert(response.bean.userId);
			       	    } else {
			       	    	$('.alert-properties').html(response.bean.resultDescription);				        	
			         	}
			         }
		       })				
				
			})
		})
	});
	
	$('.create-alert-logged').on('click', function(){
		var userId = $(this).attr('data-user-id');
		analytics.submitCreateAlert('listing-open', analyticsAlertLabel);
		var data = $('#searchLocationFilterForm').serialize();
		data+='&origin='+$(this).attr('data-origin');		
		$('.pop-up-contacto').load('/www/resem/new_design/common/pop-up-alert.jsp', data, function(){
			createAlert(userId);
		});
	})
})


function createAlert(userId){
	
	$('<input>').attr({ type: 'hidden', name: 'clientId', value : userId}).appendTo('#alert-form');
	
	var parametros = $('#alert-form').serialize();
	$.ajax({
	    data:  parametros,
	    url:   '/alertGeneratorServlet',
	    dataType : 'json',
	  	type:  'post',
	    success:  function (response) {
	    	analytics.submitCreateAlert('listing-save', analyticsAlertLabel);
			$('.alert-properties').empty();
			var alertInfo = $('.alert-info');
			alertInfo.css('padding-top', '50px');
	    	if(response.bean.resultCode === 0) {
	    		alertInfo.html('<p>'+alertCreated+'</p>');
	    	} else {
				alertInfo.html('<p>'+alertExistsText+'</p>');
	    	}
	    	onShowPopUpActions();
	    }
	});
}

function setAnalyticsAlertLabel() {
	var op = $('#searchLocationFilterForm').find("input[name='param-operation-type']").val();
	var t = $('#searchLocationFilterForm').find("input[name='param-propertyType']").val();
	var st = $('#searchLocationFilterForm').find("input[name='param-propertySubType']").val();
	var l = $('#searchLocationFilterForm').find("input[name='param-location']").val();
	
	label = "-";
	label += splitParam(op, "o");
	label += splitParam(t, "t");
	label += splitParam(st, "st");
	label += splitParam(l, "l");
	analyticsAlertLabel = label;
}

function splitParam (str, text) {
	var strSplit = str.split(",");
	var param = "";
	for (i = 0; i < strSplit.length; i++) {
		var value = strSplit[i];
		if (value != "")
			param += text + "_" + strSplit[i] + "-";
	}
	return param;
}